<div class="blank-actions">
  <div class="print-actions">
    <button (click)="printPage()" class="btn btn-primary btn-lg btn-block">
      <clr-icon shape="file-settings"></clr-icon>
    </button>
  </div>
  <div class="layout-actions">
    <strong>
      Шрифт
    </strong>
    <button class="btn btn-success" (click)="increaseFontSize()">
      <clr-icon shape="plus"></clr-icon>
    </button>
    <button class="btn btn-warning" (click)="decreaseFontSize()">
      <clr-icon shape="minus"></clr-icon>
    </button>
    <a role="tooltip" aria-haspopup="true" class="tooltip tooltip-lg tooltip-top-left">
      <clr-icon shape="info-circle" size="24"></clr-icon>
      <span class="tooltip-content">
        Розмір шрифту буде змінений тільки на цій сторінці. Для сторінки друку буде можливість зміни шрифту додатково.
      </span>
    </a>
  </div>
</div>
